import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../../app/api/agent';
import { WorkFlowSubTasks, WorkFlowTask } from '../../app/models/template';
import { Task } from '../../app/api/types';
import { uniqueId } from 'lodash';
import { initialqtSubtaskTypes, qtSubtaskTypes, uniqByKeepLast } from './smarttrackerType';
import { store } from '../../app/stores/store';
interface RestorationCutlist {
  loading:boolean,
  assetType: {
    id: string;
    elementName: string;
    options: any[];
  };
  elementType: {
    id: string;
    elementName: string;
    name?: string; // Make the name property optional
    options: any[];
  };
  department: {
    id: string;
    elementName: string;
    options: any[];
  };
  template: {
    id: string;
    elementName: string;
    options: any[];
  };
}
export default class TrackingReportStore {
  showButton = {
    start: false,
    complete: false,
    Reject: false,
    Resolve: false,
    Resume: false,
  };
  workflowCurrentAllItems: any[] = [];
  workflowCurrentTaskDetails: Task[] = [];
  workflowCurrentSubtaskDetails: WorkFlowSubTasks[] = [];
  workflowCurrentTaskId: string = '';
  workflowCurrentSubtaskId: string = '';
  sortedListItems: {
    templateId: string;
    templateName: string;
    templateDateTime: string;
    isActive: false;
    tasks: [];
  } = {
    templateId: '',
    templateName: '',
    templateDateTime: '',
    isActive: false,
    tasks: [],
  };
  listTaskItems: WorkFlowTask[] = [];
  CurrentSubtaskStatus: { status: string; value: number } = {
    status: '',
    value: 0,
  };
  workflowUpdateSearch: boolean = false;
  currWorkflowModel: boolean = false;
  productionPlanning: {
    isFromPP: boolean;
    task: string;
    subtask: string;
    taskList: any[];
    subtaskList: any[];
    showModel:boolean,
    component:any[],
    dropdownChanges:boolean
  } = {
    isFromPP: false,
    task: '',
    subtask: '',
    taskList: [],
    subtaskList: [],
    showModel:false,
    component:[],
    dropdownChanges:false
  };
  isButtonChangedForProductionPlanning = false;
  isSmartTrackerButtonLoading: boolean = false;
  restrictApiWorkflowToTemplate: string = '';
  SmarttrackerStatusUpdatedPayload :{
 itemID: string;
    actionName: string;
    subTaskName: string;
  } ={
    itemID: "",
    actionName: "",
    subTaskName: ""
  }
   bindComponent: {
    inputPath: string,
    outputPath: string,
    employeeName: string,
    rejectHistory: any[],
    defects: any[],
    model:boolean,
    status:string,
    empId:string,
    titleStatus:string,
    reelName:string,
    shortName:string,
    startFrame:string,
    endFrame:string,
    totalFrame:string,
    current_Subtask:string,
    frrInformation:string,
    loader:boolean;
    PreviousEmpId:string,
  } = {
    inputPath: '',
    outputPath: '',
    employeeName: '',
    rejectHistory: [],
    defects: [],
    model:false,
    status:'',
    empId:'',
    titleStatus:'',
    reelName:'',
    shortName:'',
    startFrame:'',
    endFrame:'',
    totalFrame:'',
    current_Subtask:'',
    frrInformation:'',
    loader:false,
    PreviousEmpId:'',
  };
  errorCheckBindComponent: {
    inputPath: string,
    outputPath: string,
    employeeName: string,
    frrInformation:string,
    rejectHistory: string,
    defects: string,
  } = {
    inputPath: '',
    outputPath: '',
    employeeName: '',
    rejectHistory: '',
    frrInformation:'',
    defects: ''
  };
  ActiveRowId:string=''
  DefectTypeSeverity:{
    DefectTypes:any[],
    Severity:any[]
  } ={
    DefectTypes:[],
    Severity:[]
  }
  FooterOperatorRemainter:string=''
  restorationCutlist: RestorationCutlist = {
    loading:false,
    assetType: { id: '', elementName: '',options:[]},
    elementType: { id: '', elementName: '' ,options:[]},
    department: { id: '',elementName: '' ,options:[]},
    template: { id: '', elementName: '' ,options:[]}
  };  
  elementDetails:any[] =[];
  reelSmarttracker:{
    tableData:qtSubtaskTypes[],
    count:number,
    isModel:boolean,
    loader:boolean
    selectedSubtask:string
  } = {
    tableData:[initialqtSubtaskTypes],
    count:0,
    isModel:false,
    loader:false,
    selectedSubtask:''
  }
  titleCode:{
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  } = {
    value: '',
    list: [],
  };
  reelSmarttrackerComponent:qtSubtaskTypes = initialqtSubtaskTypes;
  
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  statusButtonShow = (status: string) => {
    this.resetButtons();

    const lowerCaseStatus = status?.toLowerCase().replaceAll(/_/g, ' ');
    if (lowerCaseStatus === 'yet to start' || lowerCaseStatus === 'na') {
      this.showButton.start = true;
    } else if (lowerCaseStatus === 'started') {
      this.showButton.complete = true;
    } else if (lowerCaseStatus === 'completed') {
      toast.success(' Workflow Status is completed');
    } else if (lowerCaseStatus === 'hold') {
      this.showButton.Resume = true;
    } else if (lowerCaseStatus === 'rejected') {
      this.showButton.Resolve = true;
    } else if (lowerCaseStatus === 'rework') {
      // No action needed
    } else if (lowerCaseStatus === 'resume' || lowerCaseStatus === 'resumed') {
      this.showButton.complete = true;
    } else if (lowerCaseStatus === 'resolved' || lowerCaseStatus === 'clear') {
      // No action needed
    } else if (lowerCaseStatus === '') {
      this.resetButtons();
    }

    this.isSmartTrackerButtonLoading = false;
  };

  resetButtons() {
    this.showButton.start = false;
    this.showButton.complete = false;
    this.showButton.Resume = false;
    this.showButton.Resolve = false;
    this.showButton.Reject = false;
  }

  statusChanger = async (id: string, status: number) => {
    try {
      const data = await agent.QuickScan.InventoryStatusChangerPut(
        id,
        status,
        'receiving',
      );
      return data.status;
    } catch (error) {
      console.log(error);
    }
  };

  smartTrackerItemStatusChanger = async (payload: any) => {
    try {
      await agent.SmartTracker.smartTrackerItemStatusChangerAPI(payload);
      // return data.status;
    } catch (error) {
      console.log(error);
    }
  };

  SortedCurrentAllItems = async (workflowApi: any) => {
    try {
      runInAction(() => {
        this.sortedListItems = workflowApi;
        this.listTaskItems = workflowApi.tasks;
        const currentTask = workflowApi.tasks?.filter((data: any) => {
          return data?.isCurrentTask === true;
        });

        this.workflowCurrentTaskDetails = currentTask;
        const currentSubtask = currentTask[0]?.subTasks?.filter((data: any) => {
          return data?.isCurrentSubtask === true;
        });

        this.workflowCurrentSubtaskDetails = currentSubtask;

        this.workflowCurrentTaskId = currentTask[0].taskId;
        this.workflowCurrentSubtaskId = currentSubtask[0]?.subTaskId;
      });
    } catch (error) {
      console.log(error);
    }
  };
   bindComponetHandler = async (itemId: string) => {
    try {
      const [response1, response2] = await Promise.all([
        agent.SmartTracker.RestorationinputOutPath(itemId),
        agent.SmartTracker.RejectHistory(itemId)
      ]);
      return {
        inputOutPath: response1.data,
        rejectHistory: response2.data
      };
    } catch (error) {
      console.log(error);
      return null;
    }
  } 
  inputoutputHandler =(value:string,name:string)=>{
    if(name === 'input'){
      this.bindComponent.inputPath = value;
    }
    else if(name === 'output'){
      this.bindComponent.outputPath = value;
    }
    else if(name === 'frrInformation'){
      this.bindComponent.frrInformation = value;
    }
    else{
      this.bindComponent.employeeName = value;
    }
  }

  bindTableDropdown = async () => {
    try {
      const [response1, response2] = await Promise.all([
        agent.SmartTracker.DefectTypes(),
        agent.SmartTracker.SeverityTypes()
      ]);
  runInAction(()=>{
    const tempDefectTypes = response1.data.map((v:any) => ({
      key: v.defectId,
      text: v.defectName,
      value: v.defectName,
    }));

    const tempSeverityTypes = response2.data.map((v:any) => ({
      key: uniqueId(),
      text: v,
      value: v,
    }));

    this.DefectTypeSeverity.DefectTypes = tempDefectTypes;
    this.DefectTypeSeverity.Severity = tempSeverityTypes;
  })
    } catch (error) {
      console.log(error);
    }
  }
  
  OperatorRemainter = async ()=>{
    try {
      this.FooterOperatorRemainter='';
      const reponse = await agent.SmartTracker.OperatorRemainter();
      runInAction(()=>{
        this.FooterOperatorRemainter = reponse.data;
      })
    } catch (error) {
      console.log(error)
    }
  }
  handleRestorationAssetType = async (itemId:string)=>{
    try {
       this.restorationCutlist.loading = true;
      const response:any = await agent.SmartTracker.restorationAssetType(itemId);
      const departmentdetail = await agent.Departments.list();
      runInAction(() => {
      if(response.data.length === 0){
        this.restorationCutlist = {
          ...this.restorationCutlist,
          assetType: { id: '', elementName: '', options:[]},
          elementType: { id: '', elementName: '', options:[]},
          department:{ id: '', elementName: '', options:[]},
          template: { id: '', elementName: '', options:[]}
        };
      }else{
        const selectAssetType = { id: response.data[0].id, elementName: response.data[0].typeName, options:[response.data[0].typeName] }
        const tempelementType = response?.data[0]?.elementTypes?.filter((element:any)=> element.elementName === "Production Process");
        const elementType = { id: tempelementType[0]?.id, elementName: tempelementType[0].elementName, options:tempelementType}
        const template =  {id: tempelementType[0]?.templateTypes[0].templateId, elementName:tempelementType[0]?.templateTypes[0].templateName, options: tempelementType[0]?.templateTypes}
        const tempDepartment =  departmentdetail.filter((dept:any)=> dept.department_Name === "Restoration");
        const department  = {id:tempDepartment[0]?.id, elementName: tempDepartment[0]?.department_Name, options:departmentdetail}    
        this.restorationCutlist = {
          ...this.restorationCutlist,
          assetType: selectAssetType,
          elementType: elementType,
          department:department,
          template: template
        };
      }

      });
      this.restorationCutlist.loading = false;
    } catch (error) {
      console.log(error)
      this.restorationCutlist.loading = false;
    }
  }
  handleTitleCodeList = async () => {
    try {
        const titleCodeResponse = await agent.SmartTracker.titleCodeGet();
        runInAction(()=>{
          if (titleCodeResponse.data) {
            const formattedList = uniqByKeepLast(titleCodeResponse.data).map((item: any) => ({
              key: item.key || '',  // ensure these properties exist in the response
              value: item.value || '',
              text: item.text || '',
            }));
            this.titleCode.list = formattedList;
            this.titleCode.value = '';
          }
        })
    } catch (error) {
      console.error('Error fetching titleCode:', error);
    }
  };

  reelSmartrackerSearchShow = async (titleCode:string,subtask:string) => {
    try {
      this.reelSmarttracker.loader = true;
      const [response,count] = await Promise.all([
        agent.Restoration.ReelSmartrackerSearch(titleCode,subtask),
        agent.Restoration.ReelSmartrackerSearchCount(titleCode,subtask)
      ])
      runInAction(()=>{
        this.reelSmarttracker.tableData = response.data; 
        this.reelSmarttracker.count = count.data;
        this.reelSmarttracker.loader = false;
      })
    } catch (error) {
      console.log(error);
    }
  }
  reelStatusUpdate = async (status: string,restorationPayload:any) => {
    try {
      const params = {
        reelId: this.reelSmarttrackerComponent.id,
        input_Path: this.reelSmarttrackerComponent.input_Path,
        output_Path: this.reelSmarttrackerComponent.output_Path
      };
  
      await  agent.Restoration.reelStatusUpdate(status, this.reelSmarttrackerComponent)
      await  store.RestorationStore.restoratioHoursUpdate(restorationPayload)
      await  agent.Restoration.reelInputOutputPathUpdate(params)
      await  this.reelSmartrackerSearchShow(this.titleCode.value, this.reelSmarttracker.selectedSubtask)
  
      // Once all promises are resolved, run the action
      runInAction(() => {
        this.isSmartTrackerButtonLoading = false;
        this.reelSmarttracker.isModel = false;
      });
    } catch (error) {
      console.log(error);
    }
  };
  
}
  
